import styled from 'styled-components';
import { colors } from '@/styles/GlobalStyle';

export const Container = styled.aside`
  width: 100%;
  max-width: 240px;

  @media (max-width: 1040px) {
    display: none;
  }
`;

export const Item = styled.a<{ selected?: boolean }>`
  width: 100%;
  cursor: pointer;

  display: flex;
  align-items: center;
  gap: 15px;

  background: ${({ selected }) => (!selected ? 'transparent' : 'white')};

  padding: 15px 20px;

  border-radius: 13px;

  color: black;
  font-size: 15px;
  font-family: 'Sora';
  font-weight: bold;
  line-height: 18px;

  transition: 0.2s;

  svg,
  path {
    fill: black !important;
    transition: 0.1s;
  }

  :hover {
    color: ${colors.orange300};

    svg,
    path {
      fill: ${colors.orange300} !important;
    }
  }

  ::before {
    content: '';
    width: 6px;
    height: 28px;
    background: ${colors.orange400};
    border-radius: 3px;
    display: ${({ selected }) => (selected ? 'block' : 'none')};
  }

  :not(:first-child) {
    margin-top: 20px;
  }

  box-shadow: ${({ selected }) =>
    selected ? '0px 5px 16px rgba(0,0,0,0.2)' : 'none'};
`;
